import React, { Component } from 'react';
import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';
import { isBrowser, isMobile, getSignOutUrl } from '../../../../lib/utils';
import {
  SESSION_EXTENSION_DELAY,
  SESSION_EXTENSION_DELTA_MILLIS,
  SESSION_AUTH_EXPIRY,
} from '../../../../lib/constants';
import SessionExtensionModal from './SessionExtensionModal';
import theme from '@ui/theme';

const logger = (log) => {
  if (!isBrowser()) return;
  const { location } = window;
  if (
    location.href.includes('localhost') || location.href.includes('staging')
  ) {
    // eslint-disable-next-line no-console
    console.log(`SEC:${log}`);
  }
};

const RedirectTypes = {
  SIGN_IN: 'signIn',
  SIGN_OUT: 'signOut',
};

const modalStyleOverrides = {
  desktop: {
    content: {
      border: 'none',
      backgroundColor: 'transparent',
      minHeight: 'none',
      borderRadius: theme.radius.lg,
    },
  },
  mobile: {}
};

class SessionExtensionContainer extends Component {
  constructor(props) {
    super(props);

    const {
      locale = 'en',
    } = props;

    this.signOut = () => {
      window.location.href = getSignOutUrl(locale);
    };
    this.signIn = this.props.pageStateModifiers.makeAndOpenSignInModal.bind(this);
    this.setModalBody = this.props.pageStateModifiers.setModalBody.bind(this);
    this.interval = null;
  }

  componentDidMount() {
    this.checkSession();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  redirect = async (type = RedirectTypes.SIGN_IN) => {
    logger(`redirect called with ${type}`);

    switch (type) {
      case RedirectTypes.SIGN_IN:
        this.signIn();
        break;
      case RedirectTypes.SIGN_OUT:
        this.signOut();
        break;
      default:
        this.signOut();
        break;
    }
    this.stopInterval();
  };

  stopInterval = () => {
    logger('stopInterval');
    clearInterval(this.interval);
    this.interval = null;
  };

  startInterval = (expiryDate) => {
    const currentDate = new Date();
    const currentDateMillis = currentDate.getTime();
    const expiryDateMillis = expiryDate.getTime();
    const expired = expiryDateMillis <= currentDateMillis;
    const shouldOpen = (expiryDateMillis - currentDateMillis) <= SESSION_EXTENSION_DELTA_MILLIS;

    logger('startInterval:---------------START-----------------');
    logger(`startInterval:DELTA_MILLIS:${SESSION_EXTENSION_DELTA_MILLIS}`);
    logger(`startInterval:expiryDate:${expiryDate}`);
    logger(`startInterval:currentDate:${currentDate}`);
    logger(`startInterval:currentDateMillis:${currentDateMillis}`);
    logger(`startInterval:expiryDateMillis:${expiryDateMillis}`);
    logger(`startInterval:expiryDateMillis - currentDateMillis:${
      Number(expiryDateMillis - currentDateMillis)
    }`);

    logger(`startInterval:expired:${expired}`);
    logger(`startInterval:shouldOpen:${shouldOpen}`);
    logger('startInterval:--------------END------------------');

    if (expired) {
      this.stopInterval();
      this.redirect(RedirectTypes.SIGN_OUT);
      return;
    }

    if (shouldOpen) {
      // Get the integer part of the second
      const seconds = ((expiryDateMillis - currentDateMillis)/1000 >> 0);
      const ss = seconds === 0 ? 0 : seconds;

      const modal = (<SessionExtensionModal
        timer={ss}
        onCta={this.redirect}
        sessionExtensionHeadingText={this.props.sessionExtensionHeadingText}
        sessionExtensionBodyText={this.props.sessionExtensionBodyText}
        sessionExtensionSignInText={this.props.sessionExtensionSignInText}
        sessionExtensionSignOutText={this.props.sessionExtensionSignOutText}
      />);
      this.setModalBody(modal, isMobile(), modalStyleOverrides, false);
    }
  };

  checkSession = () => {
    const expiryDateCookieValue = Cookies.get(SESSION_AUTH_EXPIRY);
    logger(`checkSession:expiryDateCookieValue:${expiryDateCookieValue}`);

    if (isEmpty(expiryDateCookieValue)) {
      logger('checkSession:expiryDateCookieValue:empty cookie');
      return;
    }

    if (isNaN(expiryDateCookieValue)) {
      logger('checkSession:expiryDateCookieValue:is not a number');
      return;
    }

    const expiryDateCookie = new Date(Number(expiryDateCookieValue));
    logger(`checkSession:expiryDateCookie:${expiryDateCookie}`);

    this.interval = setInterval(() => this.startInterval(expiryDateCookie), SESSION_EXTENSION_DELAY);
  };

  render() {
    return null
  }
}

export default SessionExtensionContainer;